// Import dependencies
import { AutomatorSidebarPropertyChild } from '../_base';
import { unsafeCSS, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import global utils
import { isEmpty } from '@automator/shared/utils/is-empty';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __, sprintf } from '@wordpress/i18n';

// Import html-entities
import { decode } from 'html-entities';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-sidebar-property-textarea' )
export class AutomatorLogSidebarPropertyTextarea extends AutomatorSidebarPropertyChild {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	/**
	 * Returns the template for the label of the property
	 *
	 * @return {TemplateResult} The label of the property
	 */
	get _templateLabel() {
		return html`
			<div class="property-label">
				${ this.label } 
				<uo-chip size="small" filled>${ this.attributes.supports_html ? 'HTML' : escapeHTML( __( 'Plain text', 'uncanny-automator' ) ) }</uo-chip>
			</div>
		`;
	}

	/**
	 * Returns the template to render the value of the property
	 *
	 * @return {TemplateResult} The value of the property
	 */
	get _templateValue() {
		// Check if it's empty
		if ( isEmpty( this.value ) ) {
			return html`
				<code class="property-value">
					<em class="property-value__empty">${ escapeHTML( __( '(empty)', 'uncanny-automator' ) ) }</em>
				</code>
			`;
		}

		// Check if it contains HTML
		if ( ! this.attributes.supports_html ) {
			return html`
				<code class="property-value property-value--show-line-breaks">${ decode( this.value ) }</code>
			`;
		}

		return html`
			<div class="property-value property-value--with-code">
				<uap-log-sidebar-property-code
					.value=${ this.value }
				></uap-log-sidebar-property-code>

				<uo-button
					size="small"
					color="secondary"

					@click=${ () => {
						// Define dimensions
						const dimensions = {
							width: 800,
							height: 500
						}

						// Center the window (at least when using one monitor)
						const windowPosition = {
							x: ( screen.width / 2 ) - ( dimensions.width / 2 ),
							y: ( screen.height / 2 ) - ( dimensions.height / 2 )
						};

						// Define the window features
						const windowFeatures = [
							'toolbar=no',
							'location=no',
							'directories=no',
							'status=no',
							'menubar=no',
							'scrollbars=yes',
							'resizable=yes',

							`width=${ dimensions.width }`,
							`height=${ dimensions.height }`,
							`top=${ windowPosition.y }`,
							`left=${ windowPosition.x }`
						];

						// Create window
						const previewWindow = window.open(
							'',
							sprintf(
								/* translators: 1. Label of field */
								escapeHTML( __( '"%1$s" preview', 'uncanny-automator' ) ),
								this.label
							),
							windowFeatures.join( ',' )
						);

						// Add content
						// We're using `.innerHTML` so the scripts don't run
						previewWindow.document.body.innerHTML = this.value;
					} }
				>
					${ escapeHTML( __( 'View preview', 'uncanny-automator' ) ) }
				</uo-button>
			</div>
		`;
	}
}
